import {
  SET_SOCIAL_SECURITY_TAXES,
  SET_MEDICARE_TAXES,
  SET_GROWTH_RATE,
  SET_STATE_TAXES,
  SET_FEDERAL_TAXES
} from "./mutations";

const initialState = {
  socialSecurity: 6.2,
  medicare: 1.45,
  growthRate: 0.145,
  stateTax: 6,
  federalTax: 21,
};

const taxesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_SOCIAL_SECURITY_TAXES:
      return {
        ...state,
        socialSecurity: payload,
      };

    case SET_MEDICARE_TAXES:
      return {
        ...state,
        medicare: payload,
      };

    case SET_GROWTH_RATE:
      return {
        ...state,
        growthRate: payload,
      };

    case SET_STATE_TAXES:
      return {
        ...state,
        stateTax: payload,
      };

    case SET_FEDERAL_TAXES:
      return {
        ...state,
        federalTax: payload,
      };

    default:
      return state;
  }
};

export default taxesReducer;
